import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'
import { SpendTrackerUncategorizedCardStyled } from './styles/SpendTrackerUncategorizedCardStyled'
import { BudgetCategoryCard } from '../BudgetCategoryCard'

export interface ISpendTrackerUncategorizedCardProps {
  currentSpend: string | number
}

export const SpendTrackerUncategorizedCard = ({
  currentSpend,
}: ISpendTrackerUncategorizedCardProps) => {
  const intl = useProcurifyIntl()
  return (
    <SpendTrackerUncategorizedCardStyled>
      <BudgetCategoryCard>
        <BudgetCategoryCard.DetailsBreakdown>
          <BudgetCategoryCard.DetailsBreakdown.Row
            name={intl.formatMessage(messages.uncategorizedLabel)}
            amount={currentSpend}
            addition
          />
        </BudgetCategoryCard.DetailsBreakdown>
      </BudgetCategoryCard>
    </SpendTrackerUncategorizedCardStyled>
  )
}

SpendTrackerUncategorizedCard.displayName = 'SpendTrackerUncategorizedCard'
